import React from 'react';
import PropTypes from 'prop-types';

import CompanyLogo from 'components/CompanyLogo';
import BasicButton from 'components/BasicButton';
import crossIcon from 'assets/images/cross.png';
import RatingPoll from 'components/RatingPoll';
import LinkButton from 'components/LinkButton';
import BasicSlideToggle from 'components/BasicSlideToggle';
import FirmHeaderNavGuest from 'scenes/FirmHeader/components/FirmHeaderNavGuest';
import FirmHeaderNav from 'scenes/FirmHeader/components/FirmHeaderNav';
import TooltipIcon from 'components/TooltipIcon';

import checkmarkIcon from 'assets/images/checkmark.png';
import './styles.css';

const FirmHeader = props => {
  const {
    isLoggedIn,
    baseUrl,
    firm: { ShowRating, FirmName, Logo, Rating, RatingCount, Verified },
    tabs,
    activeTab,
    showEditFirmInfoBtn,
    isEditMode,
    onClickResponses,
    onClickAddReview,
    onClickRatingUpdate,
    onClickEditFirmInfo,
    onClickTabActiveToggle,
    onLogoEdit,
    onLogoDelete,
  } = props;

  const cls = isLoggedIn ? 'firm-header firm-header--logged-in' : 'firm-header';
  const verifiedIcon = Verified === 'Yes' ? checkmarkIcon : crossIcon;

  return (
    <div className={cls}>
      <div className="container">
        <div className="firm-header__inner">
          <div className="firm-header__logo">
            <CompanyLogo name={FirmName} logo={Logo} />
            {isEditMode && (
              <div className="firm-header__logo-controls">
                <label
                  className="firm-header__logo--label"
                  onClick={onLogoEdit}
                />
                {Logo && (
                  <label
                    className="firm-header__logo--delete"
                    onClick={onLogoDelete}
                  />
                )}
              </div>
            )}
          </div>
          <div
            className={
              isEditMode
                ? 'firm-header__content firm-header__content--edit-mode'
                : 'firm-header__content'
            }
          >
            {isLoggedIn ? (
              <div>
                <div className="firm-header__top">
                  <h2 className="firm-header__title">{FirmName}</h2>
                  {showEditFirmInfoBtn && (
                    <div className="firm-header__edit-info">
                      <LinkButton
                        text={isEditMode ? 'Back to View' : 'Edit Firm Info'}
                        controlFunc={onClickEditFirmInfo}
                      />
                    </div>
                  )}
                </div>

                <div className="firm-header__nav-wrap">
                  <FirmHeaderNav
                    tabs={tabs}
                    baseUrl={baseUrl}
                    isEditMode={isEditMode && showEditFirmInfoBtn}
                  />
                </div>
              </div>
            ) : (
              <div className="firm-header__nav-wrap">
                <FirmHeaderNavGuest tabs={tabs} baseUrl={baseUrl} />
              </div>
            )}

            <div className="firm-header__widgets">
              {!isEditMode && (
                <div className="firm-header__widgets--row">
                  <div className="firm-header__rating-info">
                    <RatingPoll
                      showRating={ShowRating}
                      rating={Rating}
                      count={RatingCount}
                      onRatingUpdateHandler={onClickRatingUpdate}
                      onLinkClickHandler={onClickResponses}
                    />
                  </div>

                  <BasicButton
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={700}
                    btnText="Add a Review"
                    btnArrow={true}
                    controlFunc={onClickAddReview}
                  />
                </div>
              )}

              <div className="firm-header__additional-widgets">
                {isEditMode ? (
                  activeTab.isPinned ? null : (
                    <div className="firm-header__toggler">
                      <label className="firm-header__toggler-label">
                        {activeTab.isActive
                          ? `Section is Active`
                          : `Section is Inactive`}
                      </label>
                      <TooltipIcon
                        content="If the toggle is On GoBuyside users will see this tab when they visit your firm page."
                        type="question"
                        contentStyle={{
                          minWidth: '230px',
                        }}
                      />
                      <BasicSlideToggle
                        name="about-tab"
                        checked={activeTab.isActive}
                        onChange={onClickTabActiveToggle}
                        disabled={activeTab.isDisabled}
                      />
                    </div>
                  )
                ) : (
                  <>
                    <span className="firm-header__verified">
                      <img
                        className="firm-header__verified-icon"
                        src={verifiedIcon}
                        alt="Verified Employer"
                      />
                      Verified Employer
                    </span>
                    <a href={'/contact'} className="firm-header__report-link">
                      Report Misuse
                    </a>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FirmHeader.propTypes = {
  isLoggedIn: PropTypes.bool.isRequired,
  baseUrl: PropTypes.string.isRequired,
  firm: PropTypes.shape({
    ShowRating: PropTypes.bool.isRequired,
    FirmName: PropTypes.string.isRequired,
    Logo: PropTypes.string.isRequired,
    Rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    RatingCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Verified: PropTypes.string,
  }).isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      alias: PropTypes.string.isRequired,
      isPinned: PropTypes.bool.isRequired,
      isActive: PropTypes.bool.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.shape({
    title: PropTypes.string.isRequired,
    alias: PropTypes.string.isRequired,
    isPinned: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
  }),
  showEditFirmInfoBtn: PropTypes.bool.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  onClickResponses: PropTypes.func.isRequired,
  onClickAddReview: PropTypes.func.isRequired,
  onClickRatingUpdate: PropTypes.func.isRequired,
  onClickEditFirmInfo: PropTypes.func.isRequired,
  onClickTabActiveToggle: PropTypes.func.isRequired,
};

export default FirmHeader;
